import { baseURL } from "../../utils/misc";


 export const getFarmerDashTopCards = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/home/farmer-dash-top-cards`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Farmer Dashboard Top Cards!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
